import { render, staticRenderFns } from "./trial-balance-v3.vue?vue&type=template&id=2a878812&scoped=true&"
import script from "./trial-balance-v3.vue?vue&type=script&lang=js&"
export * from "./trial-balance-v3.vue?vue&type=script&lang=js&"
import style0 from "./trial-balance-v3.vue?vue&type=style&index=0&id=2a878812&scoped=true&lang=css&"
import style1 from "./trial-balance-v3.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a878812",
  null
  
)

export default component.exports